import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Container } from '@mui/material';

const AuthLayout: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // If user is already logged in, redirect to dashboard
    const token = localStorage.getItem('token');
    if (token) {
      navigate('/', { replace: true });
    }
  }, [navigate]);

  return (
    <Container maxWidth={false} disableGutters>
          <Outlet />
    </Container>
  );
};

export default AuthLayout; 